import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IBullhornEntity } from '../../types/bullhorn/bullhorn-entity';
import {IJobSubmission} from '../../types/bullhorn/job-submission';

@Component({
    selector: 'app-associated-entity-selector',
    templateUrl: './associated-entity-selector.component.html',
    styleUrls: ['./associated-entity-selector.component.scss'],
    standalone: false
})
export class AssociatedEntitySelectorComponent implements OnInit {
  @Input() jobOrderLabel!: string;
  @Input() entities!: IJobSubmission[];
  @Output() entitySelected = new EventEmitter<IBullhornEntity>();
  chosenEntity!: IBullhornEntity;

  ngOnInit() {
    this.chosenEntity = this.entities[0];
    setTimeout(() => {
      this.entitySelected.emit(this.chosenEntity);
    }, 250);
  }

  modelChange(entity: IBullhornEntity) {
    console.debug('Entity selected', entity);
    this.entitySelected.emit(entity);
  }

  protected readonly Array = Array;
}
